import { useSearchParams } from 'react-router-dom'
import { useMemo, useEffect } from 'react'
import { goBack, lightImpactVibrate, onReady, updateAppStatusBar } from '../utils/appBridge'
import BackButton from '../components/ui-components/BackButton'
import DocumentViewer from '../components/DocumentViewer'
import { getDocumentUrl, getDocumentMetadata } from '../config/documentConfig'

export const PageWithDoc = () => {
  const [searchParams] = useSearchParams()

  const docParam = useMemo(() => searchParams.get('doc'), [searchParams])

  const docUrl = useMemo(() => getDocumentUrl(docParam), [docParam])
  const { title, name } = useMemo(() => getDocumentMetadata(docParam), [docParam])

  useEffect(() => {
    updateAppStatusBar('FFFFFF', 'dark')
    setTimeout(() => {
      onReady()
    }, 2000)
  }, [])

  const handleBack = () => {
    lightImpactVibrate()
    goBack()
  }

  return (
    <div className='h-full w-full flex flex-col'>
      <div className='flex pt-[18.5px] pb-4 pl-[19px] h-max'>
        <BackButton size={24} onClick={handleBack} />
      </div>
      <div className='px-5 pb-5 flex-1 flex h-32'>
        <DocumentViewer src={docUrl} title={title} name={name} />
      </div>
    </div>
  )
}
